var _jsxFileName = "/Users/pjreed/dev/mirador/dist/es/src/components/WindowTopBar.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import MenuIcon from '@material-ui/icons/MenuSharp';
import CloseIcon from '@material-ui/icons/CloseSharp';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import classNames from 'classnames';
import WindowTopMenuButton from '../containers/WindowTopMenuButton';
import WindowTopBarPluginArea from '../containers/WindowTopBarPluginArea';
import WindowTopBarPluginMenu from '../containers/WindowTopBarPluginMenu';
import WindowTopBarTitle from '../containers/WindowTopBarTitle';
import MiradorMenuButton from '../containers/MiradorMenuButton';
import FullScreenButton from '../containers/FullScreenButton';
import WindowMaxIcon from './icons/WindowMaxIcon';
import WindowMinIcon from './icons/WindowMinIcon';
import ns from '../config/css-ns';
/**
 * WindowTopBar
 */

export var WindowTopBar =
/*#__PURE__*/
function (_Component) {
  _inherits(WindowTopBar, _Component);

  function WindowTopBar() {
    _classCallCheck(this, WindowTopBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowTopBar).apply(this, arguments));
  }

  _createClass(WindowTopBar, [{
    key: "render",

    /**
     * render
     * @return
     */
    value: function render() {
      var _this$props = this.props,
          removeWindow = _this$props.removeWindow,
          windowId = _this$props.windowId,
          classes = _this$props.classes,
          toggleWindowSideBar = _this$props.toggleWindowSideBar,
          t = _this$props.t,
          windowDraggable = _this$props.windowDraggable,
          maximizeWindow = _this$props.maximizeWindow,
          maximized = _this$props.maximized,
          minimizeWindow = _this$props.minimizeWindow,
          focused = _this$props.focused,
          allowClose = _this$props.allowClose,
          allowMaximize = _this$props.allowMaximize,
          focusWindow = _this$props.focusWindow,
          allowFullscreen = _this$props.allowFullscreen,
          allowTopMenuButton = _this$props.allowTopMenuButton,
          allowWindowSideBar = _this$props.allowWindowSideBar;
      return React.createElement(AppBar, {
        position: "relative",
        color: "default",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        },
        __self: this
      }, React.createElement("nav", {
        "aria-label": t('windowNavigation'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36
        },
        __self: this
      }, React.createElement(Toolbar, {
        disableGutters: true,
        onMouseDown: focusWindow,
        className: classNames(classes.windowTopBarStyle, windowDraggable ? classes.windowTopBarStyleDraggable : null, focused ? classes.focused : null, ns('window-top-bar')),
        variant: "dense",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        },
        __self: this
      }, allowWindowSideBar && React.createElement(MiradorMenuButton, {
        "aria-label": t('toggleWindowSideBar'),
        onClick: toggleWindowSideBar,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49
        },
        __self: this
      }, React.createElement(MenuIcon, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        },
        __self: this
      })), React.createElement(WindowTopBarTitle, {
        windowId: windowId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56
        },
        __self: this
      }), allowTopMenuButton && React.createElement(WindowTopMenuButton, {
        className: ns('window-menu-btn'),
        windowId: windowId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60
        },
        __self: this
      }), React.createElement(WindowTopBarPluginArea, {
        windowId: windowId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        },
        __self: this
      }), React.createElement(WindowTopBarPluginMenu, {
        windowId: windowId,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63
        },
        __self: this
      }), allowMaximize && React.createElement(MiradorMenuButton, {
        "aria-label": maximized ? t('minimizeWindow') : t('maximizeWindow'),
        className: ns('window-maximize'),
        onClick: maximized ? minimizeWindow : maximizeWindow,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        },
        __self: this
      }, maximized ? React.createElement(WindowMinIcon, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        },
        __self: this
      }) : React.createElement(WindowMaxIcon, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70
        },
        __self: this
      })), allowFullscreen && React.createElement(FullScreenButton, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 74
        },
        __self: this
      }), allowClose && React.createElement(MiradorMenuButton, {
        "aria-label": t('closeWindow'),
        className: ns('window-close'),
        onClick: removeWindow,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77
        },
        __self: this
      }, React.createElement(CloseIcon, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82
        },
        __self: this
      })))));
    }
  }]);

  return WindowTopBar;
}(Component);
WindowTopBar.defaultProps = {
  allowClose: true,
  allowFullscreen: false,
  allowMaximize: true,
  allowTopMenuButton: true,
  allowWindowSideBar: true,
  focused: false,
  focusWindow: function focusWindow() {},
  maximized: false,
  maximizeWindow: function maximizeWindow() {},
  minimizeWindow: function minimizeWindow() {},
  t: function t(key) {
    return key;
  },
  windowDraggable: true
};